import {asyncType} from 'redux/helpers';
export const commonPageKey = 'commonPage';

export default {
   GET_DATA: asyncType(`${commonPageKey}/GET_DATA`),
   REFETCH_DATA: asyncType(`${commonPageKey}/REFETCH_DATA`),
   UPDATE_CACHE_DATA: asyncType(`${commonPageKey}/UPDATE_CACHE_DATA`),

   GET_PROXIES: asyncType(`${commonPageKey}/GET_PROXIES`),
   ADD_PROXY: asyncType(`${commonPageKey}/ADD_PROXY`),
   DELETE_PROXY: asyncType(`${commonPageKey}/DELETE_PROXY`),
   UPDATE_PROXY: asyncType(`${commonPageKey}/UPDATE_PROXY`),

   GET_SECRET_KEYS: asyncType(`${commonPageKey}/GET_SECRET_KEYS`),
   // GET_KEY: asyncType(`${commonPageKey}/GET_KEY`),
   // GET_PARTNER: asyncType(`${commonPageKey}/GET_PARTNER`),
   // GET_TRANSACTION: asyncType(`${commonPageKey}/GET_TRANSACTION`),
   POST_KEY: asyncType(`${commonPageKey}/POST_KEY`),
   SEND_DATA: asyncType(`${commonPageKey}/SEND_DATA`),
   TEST_TRANSPORT: asyncType(`${commonPageKey}/TEST_TRANSPORT`),
   GET_PARTNER: asyncType(`${commonPageKey}/GET_PARTNER`),
   // GET_TRANSACTION_SOURCE_PARTNER: asyncType(`${commonPageKey}/GET_TRANSACTION_SOURCE_PARTNER`),
   // GET_TRANSACTION_DESTINATION_PARTNER: asyncType(`${commonPageKey}/GET_TRANSACTION_DESTINATION_PARTNER`),
   UPDATE_PARTNER: asyncType(`${commonPageKey}/UPDATE_PARTNER`),

   PERSIST_DIRTY_VALUES_GETTER: `${commonPageKey}/PERSIST_DIRTY_VALUES_GETTER`,
   FLUSH_DIRTY_VALUES_GETTER: `${commonPageKey}/FLUSH_DIRTY_VALUES_GETTER`,
};
